import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SchoolDocMasterCreateRequestDTO, SchoolDocMasterDTO, SchoolDocMasterUpdateRequestDTO, SchoolDocMasterList, SchoolDocMasterDeleteRequestDTO, SchoolDocMasterReadByIdRequestDTO, SchoolDocMasterReadByMasterIdRequestDTO, SchoolDocMasterReadByMasterTypeRequestDTO, SchoolDocMasterCreateBulkRequestDTO } from './school-doc-master.interface';
import { SchoolDocMaster_Create, SchoolDocMaster_Update, SchoolDocMaster_ReadAll, SchoolDocMaster_Delete, SchoolDocMaster_ReadById, SchoolDocMaster_ReadByMasterId, SchoolDocMaster_ReadByMasterType, SchoolDocMaster_CreateBulk, SchoolDocMaster_ExternalCreateBulk, SchoolDocMaster_ExternalReadByMasterId } from 'src/app/GlobalVariable';

@Injectable({
  providedIn: 'root'
})
export class SchoolDocMasterService {

  constructor() { }
    http = inject(HttpClient)
  
  
    SchoolDocMaster_Create(data: SchoolDocMasterCreateRequestDTO): Observable<SchoolDocMasterDTO> {
      return this.http.post<SchoolDocMasterDTO>(SchoolDocMaster_Create, data)
    }
  
    SchoolDocMaster_Update(data: SchoolDocMasterUpdateRequestDTO): Observable<SchoolDocMasterDTO> {
      return this.http.post<SchoolDocMasterDTO>(SchoolDocMaster_Update, data)
    }
  
    SchoolDocMaster_ReadAll(): Observable<SchoolDocMasterList> {
      return this.http.get<SchoolDocMasterList>(SchoolDocMaster_ReadAll)
    }
    SchoolDocMaster_Delete(data: SchoolDocMasterDeleteRequestDTO): Observable<void> {
      return this.http.post<void>(SchoolDocMaster_Delete, data)
    }
  
  
    SchoolDocMaster_ReadById(data: SchoolDocMasterReadByIdRequestDTO): Observable<SchoolDocMasterDTO> {
      return this.http.post<SchoolDocMasterDTO>(SchoolDocMaster_ReadById, data)
    }
  
    SchoolDocMaster_ReadByMasterId(data: SchoolDocMasterReadByMasterIdRequestDTO): Observable<SchoolDocMasterList> {
      return this.http.post<SchoolDocMasterList>(SchoolDocMaster_ReadByMasterId, data)
    }

    SchoolDocMaster_ExternalReadByMasterId(data: SchoolDocMasterReadByMasterIdRequestDTO): Observable<SchoolDocMasterList> {
      return this.http.post<SchoolDocMasterList>(SchoolDocMaster_ExternalReadByMasterId, data)
    }
  
    SchoolDocMaster_ReadByMasterType(data: SchoolDocMasterReadByMasterTypeRequestDTO): Observable<SchoolDocMasterList> {
      return this.http.post<SchoolDocMasterList>(SchoolDocMaster_ReadByMasterType, data)
    }

    SchoolDocMaster_CreateBulk(data: SchoolDocMasterCreateBulkRequestDTO): Observable<SchoolDocMasterList> {
      return this.http.post<SchoolDocMasterList>(SchoolDocMaster_CreateBulk, data);
    }

    SchoolDocMaster_ExternalCreateBulk(data: SchoolDocMasterCreateBulkRequestDTO): Observable<SchoolDocMasterList> {
      return this.http.post<SchoolDocMasterList>(SchoolDocMaster_ExternalCreateBulk, data);
    }
}
